import React from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
function Toast(props) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={props.open}
      autoHideDuration={1000}
      onClose={() => props.setClose(false)}
    >
      <Alert anchorOrigin style={{ width: "400px", height: "50px" }} severity={props.type}>{props.text}</Alert>
    </Snackbar>
  );
}

export default Toast;
